import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom"; // Zmiana useHistory na useNavigate
import { usePopup } from "../../context/PopupContext";
import Loader from "./../../components/Loader";
import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';

const SUBSCRIBE_MUTATION = gql`
    mutation productAlertsSubscribe($product_id: String!) {
        productAlertsSubscribe(product_id: $product_id) {
            status
            message
        }
    }
`;

const ProductAlertSubscribe = () => {
    const navigate = useNavigate(); // Zamiana useHistory na useNavigate
    const params = useParams();
    const { showAddToCartPopupMessage } = usePopup();
    const [subscribe, { loading }] = useMutation(SUBSCRIBE_MUTATION, {
        fetchPolicy: "no-cache",
    });

    useEffect(() => {
        // Sprawdzamy, czy params istnieją
        if (!params || !params.productId) {
            navigate("/");
            return;
        }

        // Wykonanie mutacji
        subscribe({
            variables: {
                product_id: params.productId,
            },
        })
            .then((result) => {
                const data = result.data.productAlertsSubscribe;
                if (data) {
                    showAddToCartPopupMessage(
                        data.message,
                        data.status === true ? "success" : "error",
                        4000
                    );
                }
                // Przekierowanie po zakończeniu
                navigate(params.productUrl ? `/${params.productUrl}` : "/");
            })
            .catch((error) => {
                console.error("Subscription error:", error);
                showAddToCartPopupMessage(
                    "Failed to subscribe to product alerts",
                    "error",
                    4000
                );
                navigate("/");
            });
    }, [params, navigate, subscribe, showAddToCartPopupMessage]); // Dodane zależności

    // Wyświetlanie loadera podczas ładowania
    return <Loader />;
};

export default ProductAlertSubscribe;